import React from "react";

const ContentHeading = ({ title, ...props }) => {
    return (
        <div className={"content-heading " + props.className}>
            <div className={"background " + props.hideFirst}></div>
            <span className="title"><nobr>{title}</nobr></span>
            <div className="background"></div>
        </div>
    );
};
export default ContentHeading;